import type { DomainRouterJsonInput } from '../entities/domain-router-transport';

export type AdminImpersonationSession = {
  sessionId: string;
  actorId: string;
  actorEmail: string;
  effectiveUserId: string;
  effectiveUserName: string;
  effectiveUserEmail: string;
  targetPersona?: 'administrator' | 'staff' | 'parent' | string;
  startedAt: string;
  reason: string;
};

export type AdminViewAsContext = {
  actorId: string;
  userId: string;
  userName: string;
  userEmail: string;
  startedAt: string;
};

export type TenantSchool = {
  schoolId: string;
  schoolName: string;
  tenantId: string;
};

export type ActiveSchoolContext = {
  schoolId: string | null;
};

export type LaunchImpersonationSessionResult = {
  session: AdminImpersonationSession;
};

export type SetViewAsContextResult = {
  context: AdminViewAsContext;
};

export const ADMIN_GOVERNANCE_QUERY_OPERATION_IDS = [
  'getImpersonationSession',
  'getViewAsContext',
  'listTenantSchools',
  'getActiveSchoolContext',
] as const;

export const ADMIN_GOVERNANCE_MUTATION_OPERATION_IDS = [
  'launchImpersonationSession',
  'clearImpersonationSession',
  'setViewAsContext',
  'clearViewAsContext',
  'switchSchoolContext',
] as const;

export type AdminGovernanceQueryOperationId =
  (typeof ADMIN_GOVERNANCE_QUERY_OPERATION_IDS)[number];
export type AdminGovernanceMutationOperationId =
  (typeof ADMIN_GOVERNANCE_MUTATION_OPERATION_IDS)[number];

export type AdminGovernanceQueryArgsMap = {
  getImpersonationSession: Record<string, never>;
  getViewAsContext: Record<string, never>;
  listTenantSchools: Record<string, never>;
  getActiveSchoolContext: Record<string, never>;
};

export type AdminGovernanceQueryResultMap = {
  getImpersonationSession: AdminImpersonationSession | null;
  getViewAsContext: AdminViewAsContext | null;
  listTenantSchools: { schools: TenantSchool[] };
  getActiveSchoolContext: ActiveSchoolContext;
};

export type AdminGovernanceMutationArgsMap = {
  launchImpersonationSession: { input: DomainRouterJsonInput };
  clearImpersonationSession: { input: DomainRouterJsonInput };
  setViewAsContext: { input: DomainRouterJsonInput };
  clearViewAsContext: { input: DomainRouterJsonInput };
  switchSchoolContext: { input: DomainRouterJsonInput };
};

export type AdminGovernanceMutationResultMap = {
  launchImpersonationSession: LaunchImpersonationSessionResult;
  clearImpersonationSession: { cleared: true };
  setViewAsContext: SetViewAsContextResult;
  clearViewAsContext: { cleared: true };
  switchSchoolContext: ActiveSchoolContext;
};
